import { render, staticRenderFns } from "./Reader.vue?vue&type=template&id=75b043c8&scoped=true&"
import script from "./Reader.vue?vue&type=script&lang=js&"
export * from "./Reader.vue?vue&type=script&lang=js&"
import style0 from "./Reader.vue?vue&type=style&index=0&id=75b043c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b043c8",
  null
  
)

export default component.exports